module.exports = __webpack_public_path__ + "fonts/WorkSans-ExtraBold.c568730.woff2";